"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _button = _interopRequireDefault(require("@ux/button"));
var _search = _interopRequireDefault(require("@ux/search"));
var _button2 = _interopRequireDefault(require("../merch-button/button.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intentsConfig = _interopRequireDefault(require("../merch-button/intents.config.js"));
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "ButtonWrapper",
  class: "core-bqv22y1"
});
const formStyles = "core-f19dylnx";
const searchStyles = "core-srlqdtp";
const text = "core-t1q8mq2c";
const icon = "core-i1fwvzaf";
const iconOnlyButtonStyles = "core-i1ifc4y9";
/**
 * Render input with button control.
 *
 * @param {Object} props React props for for element
 * @param {Object} props.button UXCore Button props, note: if you don't specify text, then the button will always be an icon
 * @param {string} props.id unique ID
 * @param {String} props.partial Theme partial
 *
 * @returns {React.ReactElement} Input element with controls
 * @public
 */
function InputBar({
  inputFieldName,
  id = 'input-bar',
  _name,
  initialValue = '',
  ariaButtonLabel,
  ariaInputLabel,
  placeholder,
  label = '',
  hideLabel = true,
  button,
  handleChange,
  handleOnChange,
  list,
  invert,
  partial,
  ...rest
}) {
  button = {
    type: 'submit',
    design: 'primary',
    ...button
  };

  // Define control set where either button is hidden through CSS at specific breakpoints.
  const controls = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ButtonWrapper, (0, _extends2.default)({}, button, {
    id: `button-${button?.id || 'input-submit'}`,
    className: text,
    "data-cy": "submit"
  }, _patternLibraryUtils.tracking.create(_name, true, false))), /*#__PURE__*/_react.default.createElement(ButtonWrapper, (0, _extends2.default)({
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "search",
      width: 18,
      height: 18
    })
  }, button, {
    id: `icon-${button?.id || 'input-submit'}`,
    text: "",
    "aria-label": ariaButtonLabel,
    className: icon,
    "data-cy": "submit"
  }, _patternLibraryUtils.tracking.create(_name, true, false))));
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-partial": partial || (invert ? 'dark1' : ''),
    className: `${formStyles}
      ${button.text ? searchStyles : iconOnlyButtonStyles}`,
    "data-cy": "input-bar-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_search.default, (0, _extends2.default)({}, rest, {
    id: id,
    onChange: handleChange ? e => handleChange(e.target.value) : handleOnChange,
    "data-cy": "input-bar",
    name: inputFieldName,
    defaultValue: initialValue,
    label: label,
    hideLabel: hideLabel,
    placeholder: placeholder,
    "aria-label": ariaInputLabel,
    button: controls,
    clearable: true,
    suggestion: list,
    className: "input-parent"
  })));
}
InputBar.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  initialValue: _propTypes.default.string,
  label: _propTypes.default.string,
  hideLabel: _propTypes.default.bool,
  button: _propTypes.default.shape(_button2.default.propTypes),
  placeholder: _propTypes.default.string,
  ariaInputLabel: _propTypes.default.string,
  ariaButtonLabel: _propTypes.default.string,
  inputFieldName: _propTypes.default.string,
  handleChange: _propTypes.default.func,
  handleOnChange: _propTypes.default.func,
  list: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  ..._search.default.propTypes
};